import gql from "graphql-tag";

export default gql`
	mutation refuseBankAccount($bank_id: ID!) {
		refuseBankAccount(bankId: $bank_id) {
			id
		}
	}
`;
